import {calculateNumberToDay} from "../../compare/Compare";
import React from "react";

function SlaReportStaticRowsWithTime({ title, item, labels, className = "" }) {
    const rowClass = className || undefined;

    return (
        <>
            <tr className={rowClass}>
                <th className="fieldset-th-sla" rowSpan={6} colSpan={2}>{title}</th>
                <th className="fieldset-th-sla">가중치</th>
                <td className="fieldset-td-sla">{item.weight || 0} %</td>
            </tr>
            <tr className={rowClass}>
                <th className="fieldset-th-sla">{labels[0]}</th>
                <td className="fieldset-td-sla">{item.countOne || 0}</td>
            </tr>
            <tr className={rowClass}>
                <th className="fieldset-th-sla">{labels[1]}</th>
                <td className="fieldset-td-sla">{item.countTwo || 0}</td>
            </tr>
            <tr className={rowClass}>
                <th className="fieldset-th-sla">{labels[2]}</th>
                <td className="fieldset-td-sla">{calculateNumberToDay(item.timeOne)}</td>
            </tr>
            <tr className={rowClass}>
                <th className="fieldset-th-sla">평가점수</th>
                <td className="fieldset-td-sla">{item.evaluationScore || 0} %</td>
            </tr>
            <tr className={rowClass}>
                <th className="fieldset-th-sla">환산점수</th>
                <td className="fieldset-td-sla">{item.convertedScore || 0} %</td>
            </tr>
        </>
    );
}

export default SlaReportStaticRowsWithTime